<p-dialog
  [style]="{ width: '240px', maxWidth: '90%' }"
  [draggable]="false"
  [modal]="true"
  [closable]="false"
  [(visible)]="alertController.loading"
>
  <div class="flex justify-center">
    <em class="pi pi-spin pi-spinner text-8xl text-primary mb-4"></em>
  </div>
  <h4 class="text-center">LOADING...</h4>
</p-dialog>
